/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('input', {
    ref: "upload",
    attrs: {
      "type": "file",
      "name": "fileUpload",
      "accept": _vm.accept.join(',')
    },
    on: {
      "change": _vm.onFileChange
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };